<template>
    <div>
        <common-loading-icon
            v-if="isPageLoading"
            :upperText="$t('layouts.app.loading.heading_one')"
            :lowerText="$t('layouts.app.loading.heading_two')"
        ></common-loading-icon>

        <div :class="layoutClass">
            <header v-if="showHeader" class="auth-layout__header">
                <router-link :to="{ name: 'index' }" class="auth-layout__logo">
                    <svg>
                        <use xlink:href="#picture-logo" />
                    </svg>
                </router-link>

                <p class="auth-layout__byword">
                    <slot name="byword">
                        {{ byword }}
                    </slot>
                </p>
            </header>

            <main class="auth-layout__content">
                <common-content-spacer height="medium">
                    <common-content-wrapper width="small">
                        <common-progress :percentage="progress" :isBarHidden="isProgressBarHidden"></common-progress>
                    </common-content-wrapper>

                    <slot></slot>
                </common-content-spacer>

                <terms-of-use v-if="!hideTerms"></terms-of-use>
            </main>

            <aside v-if="$slots.aside" class="auth-layout__aside">
                <slot name="aside"></slot>
            </aside>

            <portal-target name="modals"></portal-target>
        </div>
    </div>
</template>

<script>
    import TermsOfUse from 'components/page-elements/terms-of-use/TermsOfUseFooter'
    import VersionUpdateServiceWorkerMixin from 'mixins/VersionUpdateServiceWorkerMixin'

    export default {
        mixins: [VersionUpdateServiceWorkerMixin],

        components: {
            TermsOfUse,
        },

        props: {
            isPlain: { type: Boolean, default: false },
            byword: { type: String, default: undefined },
            image: { type: Number, default: 1 },
            progress: { type: Number, default: 0 },
            isProgressBarHidden: { type: Boolean, default: false },
            showHeader: { type: Boolean, default: true },
            hideTerms: { type: Boolean, default: false },
            isCompact: { type: Boolean, default: false },
            isPageLoading: { type: Boolean, default: false },
        },

        computed: {
            layoutClass() {
                return {
                    'auth-layout': true,
                    'auth-layout--plain': this.isPlain,
                    'auth-layout--compact': this.isCompact,
                    [`auth-layout--image-${this.image}`]: !this.isPlain,
                    'auth-layout--loading': this.isPageLoading,
                }
            },
        },
    }
</script>
